import { useNavigate } from 'react-router-dom';

import { updateVerificationToken } from '../../../../utils';

interface INavigateToRedirect {
  accessToken: string;
  refreshToken: string;
  features: Record<string, string>;
}

const useLoginRedirect = () => {
  const navigate = useNavigate();

  // Navigate to "Redirect" page with login tokens and permissions
  const navigateToRedirect = ({ accessToken, refreshToken, features }: INavigateToRedirect) => {
    if (!accessToken || !refreshToken) {
      return console.log('Missing accessToken or refreshToken while login ', {
        accessToken,
        refreshToken,
      });
    }

    updateVerificationToken('');

    navigate(`/redirect`, {
      state: {
        accessToken,
        refreshToken,
        features,
      },
    });
  };

  return { navigateToRedirect };
};

export default useLoginRedirect;
